import styled, { keyframes } from 'styled-components';
import { scale, isMobile } from '@/utils/constants';
import bg_img from './bg_img.svg';
const setRem = (base: number, target: number) => (base / 100) * (100 / target);
const myRotate = keyframes`
  to {
    transform: rotate(360deg);
  }
}

`;
export const VoiceLoadingImg = styled.img`
  width: ${isMobile ? '52px' : '80px'};
  height: ${isMobile ? '52px' : '80px'};
  animation: ${myRotate} 1s linear infinite;
`;

export const VerifyVoiceWrap = styled.div<{
  theme: {
    [key: string]: any;
  };
}>`
  position: relative;
  ${({ theme }) => `
    &.captcha_verify_voice-mobile {
      .captcha_verify_voice_bar {
        padding: 0.36em 0.2em 0.16em;
        line-height: 0.24em;
        min-height: 0.24em;
        outline: none;
      }
      .captcha_verify_voice_bar--title_wrap {
        display: flex;
        align-items: center;
        font-size: ${theme.titleSize || '0.19em'}
        color: ${theme.titleColor};
        width: 100%;
        box-sizing: border-box;
        outline: none;
      }
      .captcha_verify_voice_bar--title {
        max-width: ${setRem(276 * scale, 17)}em;
        width: 100%;
        text-align: left;
        outline: none;
      }
      .captcha_verify_voice_click_block {
        margin: 0 0.2em;
        background-color: #313547;
        background-image: url(${bg_img});
        height: 0.7em;
        display: flex;
        justify-content: center;
        align-items: center;
        background-size: cover;
        border-radius: 4px;
        outline: none;
      }
      .captcha_verify_voice_click_block--text_wrap {
        height: 0.22em;
        line-height: 0.22em;
        padding-left: 0.08em;
      }
      .captcha_verify_voice_click_block--text {
        font-size: 0.17em;
        color: #fff;
      }
      .captcha_verify_voice_input_wrap {
        margin: 0.12em 0.2em 0;
        height: 0.4em;
      }
      .captcha_verify_voice_input {
        font-size: 0.14em;
        float: left;
        height: 100%;
        border: none;
        border-style: none;
        // outline: none;
        padding: 0;
        width: 100%;
        background: ${theme.voiceInputBgColor || '#f2f2f2'};
        padding-left: ${(0.12 * 100) / 14}em;
        caret-color: ${theme.voiceInputCaretColor || '#1a74ff'};
        color: ${theme.voiceInputColor || '#222222'};
        box-sizing: border-box;
        border-radius: 4px;
        &::placeholder {
          color: ${theme.voiceInputPlaceholderColor || '#999999'};
        }
        &::-webkit-outer-spin-button,
        &::-webkit-inner-spin-button {
          -webkit-appearance: none;
        }
        &[type='number'] {
          -moz-appearance: textfield;
        }
        @supports (-webkit-mask: none) and (not (cater-color: ${
          theme.voiceInputCaretColor || '#1a74ff'
        })) {
          .captcha_verify_voice_input {
            color: ${theme.voiceInputCaretColor || '#1a74ff'};
          }
          .captcha_verify_voice_input::first-line {
            color: ${theme.voiceInputColor || '#222222'};
          }
        }
      }
      .captcha_verify_voice_footer_btn {
        flex: 1;
        font-size: 0.16em;
        text-align: center;
        display: flex;
        justify-content: center;
        flex-flow: column;
        outline: none;
      }
      .captcha_verify_voice_footer--normal {
        margin-top: 0.2em;
        height: 0.435em;
        display: flex;
        border-top: 0.5px solid #f2f2f2;
      }
      .captcha_verify_voice_footer--normal_btn1,
      .captcha_verify_voice_footer--not_normal_btn1 {
        color: ${theme.voiceMobileBtn1Color || '#f04142'};
      }
      .captcha_verify_voice_footer--normal_btn2,
      .captcha_verify_voice_footer--not_normal_btn2 {
        color: ${theme.voiceMobileBtn2Color || '#505050'};
        border-left: 0.5px solid #f2f2f2;
      }
      .captcha_verify_voice_footer--not_normal_wrap {
  
      }
      .captcha_verify_voice_footer--not_normal_content_wrap {
        font-size: 0.17em;
        height: 100%;
        width: 100%;
        position: absolute;
        top: 0;
        left: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        box-sizing: border-box;
        padding-bottom: ${(0.05 * 100) / 17}em;
        span {
          margin-top: ${(0.25 * 100) / 17}em;
        }
      }
      .captcha_verify_voice_footer--not_normal_btn_wrap {
        margin-top: 0.2em;
        height: 0.435em;
        display: flex;
        border-top: 0.5px solid #f2f2f2;
        position: absolute;
        bottom: 0;
        z-index: 1;
        width: 100%;
      }
    }

    &.captcha_verify-voice-web {
      .captcha_verify_voice_bar {
        padding: 0.28em 0.48em 0.16em 0.20em;
      }
      .captcha_verify_voice_bar--title {
        font-size: 0.16em;
      }
      .captcha_verify_voice_click_block {
        margin: 0 0.2em;
        background-color: #313547;
        background-image: url(${bg_img});
        height: 0.8em;
        display: flex;
        justify-content: center;
        align-items: center;
        background-size: cover;
        border-radius: 4px;
        cursor: pointer;
      }
      .captcha_verify_voice_click_block--text_wrap {
        height: 0.22em;
        line-height: 0.22em;
        padding-left: 0.08em;
      }
      .captcha_verify_voice_click_block--text {
        font-size: 0.17em;
        color: #fff;
      }
      .captcha_verify_voice_input_wrap {
        margin: 0.12em 0.2em 0;
        height: 0.32em;
      }
      .captcha_verify_voice_input {
        font-size: 0.14em;
        float: left;
        height: 100%;
        border: 1px solid #E8E8E8;
        // outline: none;
        padding: 0;
        width: 100%;
        background: ${theme.voiceInputBgColor || '#ffffff'};
        padding-left: ${(0.12 * 100) / 14}em;
        caret-color: ${theme.voiceInputCaretColor || '#1a74ff'};
        color: ${theme.voiceInputColor || '#222222'};
        box-sizing: border-box;
        border-radius: 4px;
        &::placeholder {
          color: ${theme.voiceInputPlaceholderColor || '#BFBFBF'};
        }
        &::-webkit-outer-spin-button,
        &::-webkit-inner-spin-button {
          -webkit-appearance: none;
        }
        &[type='number'] {
          -moz-appearance: textfield;
        }
        @supports (-webkit-mask: none) and (not (cater-color: ${
          theme.voiceInputCaretColor || '#1a74ff'
        })) {
          .captcha_verify_voice_input {
            color: ${theme.voiceInputCaretColor || '#1a74ff'};
          }
          .captcha_verify_voice_input::first-line {
            color: ${theme.voiceInputColor || '#222222'};
          }
        }
      }
      .captcha_verify_voice_footer_btn {
        font-size: 0.14em;
        border-radius: 4px;
        padding: 6px 16px;
        cursor: pointer;
      }
      .captcha_verify_voice_footer--normal,
      .captcha_verify_voice_footer--not_normal_btn_wrap {
        display: flex;
        justify-content: flex-end;
        padding: 28px 20px;
      }
      .captcha_verify_voice_footer--normal_btn2,
      .captcha_verify_voice_footer--not_normal_btn2 {
        margin-left: 16px;
        border: 1px solid ${theme.voiceWebBtn2BorderColor || '#D8D8D8'};
        box-sizing: border-box;
        color: ${theme.voiceWebBtn2Color || '#222222'};
        background: ${theme.voiceWebBtn2BgColor || '#ffffff'};

      }
      .captcha_verify_voice_footer--normal_btn1,
      .captcha_verify_voice_footer--not_normal_btn1 {
        color: ${theme.voiceWebBtn1Color || '#ffffff'};
        border: 1px solid ${theme.voiceWebBtn1BorderColor || 'transparent'};
        box-sizing: border-box;
        background: ${theme.voiceWebBtn1BgColor || '#FF5E5E'};
      }
      // 异常状态
      .captcha_verify_voice_footer--not_normal_content_wrap {
        font-size: 0.17em;
        height: 100%;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        box-sizing: border-box;
        padding-top: 36px;
        span {
          margin-top: 20px;
          font-size: ${(0.16 * 100) / 17}em;
          color: #222222;
          font-weight: 500;
        }
      }
      .captcha_verify_voice_footer--not_normal_btn1 {
      }
    }
  `}
`;
